<template>
  <v-layout column class="info-width">
    <!-- MESSAGES -->
    <v-dialog
      v-model="showMessage"
      max-width="390"
      persistent
    >
      <v-card width="390">
        <v-card-title primary-title>
          <div>
            <div class="headline">{{ messageToShow }}</div>
            <span>
              Ésta alarma ha sido justificada por otro usuario.
            </span>
          </div>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            @click="closeMessage"
          >
            <v-icon left>clear</v-icon>
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- JUSTIFICATION COMPONENT -->
    <v-dialog
      v-model="showJustification"
      max-width="390"
      persistent
    >
      <justification-alert
        :alarm='alarmSelected'
        @showDialog='showJustification = false'
        @showMessage='showMessageIn'
      />
    </v-dialog>
    <!-- INFO ALERTS -->
    <v-flex d-inline-flex align-center class="general-info-container" pa-3 mb-1>
      <v-flex style="max-width: 250px; min-width: 250px;">
        <h2>Ingreso a Geocerca</h2>
      </v-flex>
      <v-flex
        v-if="!loadingGeofenceInAlarms"
        style="max-width: 190px; min-width: 190px;"
      >
        <h3 class="pl-2"><span class="body-2">Total Alarmas:</span> {{ geofenceInAlarms.length }}</h3>
      </v-flex>
    </v-flex>
    <!-- HEADER -->
    <v-flex d-flex py-1 mb-1 class="text-xs-left header-container">
      <v-flex class="text-xs-left info-mission" pl-4>Nombre</v-flex>
      <v-flex ml-5 class="description-style">Descripción</v-flex>
      <v-flex >Vehículos</v-flex>
    </v-flex>
    <!-- LOADING -->
    <v-flex v-if="loadingGeofenceInAlarms" pa-5>
      <v-progress-circular indeterminate color="white"></v-progress-circular>
      Cargando datos...
    </v-flex>
    <!-- CONTENT -->
    <v-flex v-else>
      <!-- ALARM DATA -->
      <v-flex v-if="geofenceInAlarms.length > 0">
        <v-expansion-panel focusable>
          <v-expansion-panel-content
            v-for="(alarm, index) in geofenceInAlarms"
            :key="index">
            <!-- HEADER -->
            <template v-slot:header>
              <v-flex d-flex class="text-xs-left" align-center>
                <v-flex class="info-mission">
                  {{ alarm.name }}
                </v-flex>
                <v-flex pl-2 class="description-style">{{ alarm.description }}</v-flex>
                <!-- <v-flex offset-xs1>{{ alarm.where }}</v-flex> -->
                <v-flex ml-5 offset-xs0>{{ alarm.vehicles.length }}</v-flex>
              </v-flex>
            </template>
            <!-- CONTENT -->
            <v-card class="pt-3" color="grey darken-4">
              <v-card-text>
                <h3 class="ml-3">Vehículos</h3>
                <v-flex ml-3 mb-1 px-2>
                  <v-flex d-inline-flex class="body-2 grey--text">
                    <v-flex class="plate-style caption font-weight-bold">
                      Placa
                    </v-flex>
                    <v-flex class="code-style caption font-weight-bold">
                      Código/Sigla
                    </v-flex>
                    <v-flex class="agency-style caption font-weight-bold">
                      Agencia
                    </v-flex>
                    <v-flex class="geofence-style caption font-weight-bold">
                      Geocerca
                    </v-flex>
                    <v-flex class="duration-style caption font-weight-bold">
                      Duración
                    </v-flex>
                    <v-flex class="date-style caption font-weight-bold">
                      Desde
                    </v-flex>
                    <v-flex class="date-style caption font-weight-bold">
                      Hasta
                    </v-flex>
                    <v-flex class="justification-style caption font-weight-bold">
                      Justificación
                    </v-flex>
                  </v-flex>
                </v-flex>
                <v-flex
                  v-for="(vehicle, index) in alarm.vehicles"
                  :key="index"
                  pl-3>
                  <v-flex 
                    d-inline-flex
                    align-center
                    :class="[index % 2 ? '' : rowbg]"
                    class="info-vehicle-in caption"
                    px-2
                    py-1
                  >
                    <v-flex class="plate-style">
                      <router-link class="caption" :to="`/vehicles/${vehicle.id}`">
                        {{ vehicle.licensePlate === null ? '' : vehicle.licensePlate }}
                      </router-link>
                    </v-flex>
                    <v-flex class="code-style">
                      <router-link class="caption" :to="`/vehicles/${vehicle.id}`">
                        {{ vehicle.code === null ? '' : vehicle.code }}
                      </router-link>
                    </v-flex>
                    <v-flex class="agency-style">
                      {{ vehicle.agencyId | agencyName }}
                    </v-flex>
                    <v-flex class="geofence-style">
                      {{ vehicle.polygonName }}
                    </v-flex>
                    <v-flex class="duration-style">
                      {{ vehicle.duration | secondsToHHMMSS }}
                    </v-flex>
                    <v-flex class="date-style">
                      {{ vehicle.startTime | filterFullDate }}
                    </v-flex>
                    <v-flex class="date-style">
                      {{ vehicle.endTime | filterFullDate }}
                    </v-flex>
                    <v-flex class="justification-style">
                      <v-flex
                        v-if="vehicle.isJustified === null"
                        :class="vehicle.userInProgressRemote ? 'in-progress-state' : ''"
                        d-inline-flex
                        align-center
                      >
                        <!-- NULL -->
                        <v-btn
                          fab
                          small
                          flat
                          :disabled="vehicle.justificationInProgress"
                          @click="justifyAlert(vehicle, alarm.name, alarm.description)"
                        >
                          <v-icon
                            v-if="vehicle.userInProgressRemote"
                            color="grey lighten-1"
                          >
                            textsms
                          </v-icon>
                          <v-icon
                            v-else
                            color="grey lighten-1"
                          >
                            chat_bubble
                          </v-icon>
                        </v-btn>
                        <!-- USER IN PROGRESS -->
                        <v-tooltip
                          left
                          color="amber lighten-2 grey--text text--darken-3"
                        >
                          <template v-slot:activator="{ on }">
                            <v-icon
                              v-if="vehicle.userInProgressRemote"
                              class="hover-icon"
                              style="margin-left:-15px"
                              color="amber"
                              v-on="on"
                            >
                              record_voice_over
                            </v-icon>
                          </template>
                          <span>
                            ...justificando
                            <br />
                             <b>{{ vehicle.userInProgressRemote }}</b>
                          </span>
                        </v-tooltip>
                      </v-flex>
                      <!-- FALSE -->
                      <v-btn
                        v-else-if="vehicle.isJustified === false"
                        fab
                        small
                        flat
                        @click="justifyAlert(vehicle, alarm.name, alarm.description)"
                      >
                        <v-icon color="error">report_off</v-icon>
                      </v-btn>
                      <!-- TRUE -->
                      <v-btn
                        v-else-if="vehicle.isJustified === true"
                        fab
                        small
                        flat
                        @click="justifyAlert(vehicle, alarm.name, alarm.description)"
                      >
                        <v-icon color="success">message</v-icon>
                      </v-btn>
                    </v-flex>
                  </v-flex>
                </v-flex>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>
      <!-- MESSAGE -->
      <v-flex v-else px-3 py-3>
        <h2>En éste momento no hay alarmas por ingreso a geocerca.</h2>
        <p>A medida que se generen nuevas alarmas, éstas se cargaran automáticamente.</p>
      </v-flex>
    </v-flex>
  </v-layout>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'

  import JustificationAlert from './JustificationAlert'

  export default {
    name: 'geofence-in-alerts',
    components: {
      JustificationAlert
    },
    data() {
      return {
        rowbg: 'bg-row',
        alarmSelected: {},
        showJustification: false,
        intervalGeofenceInAlarmsValue: 20000,
        intervalGeofenceInAlarmsInstance: null,
        showMessage: false,
        messageToShow: ''
      }
    },
    computed: {
      ...mapGetters([
        'loadingGeofenceInAlarms',
        'geofenceInAlarms',
        'pusherRef'
      ]),
      ...mapGetters({
        user: 'auth/getProfile'
      })
    },
    methods: {
      ...mapActions([
        'setLoadingGeofenceInAlarms',
        'fetchGeofenceInAlarms',
        'clearGeofenceInAlarms'
      ]),
      justifyAlert(alert, alarmName, alarmDescription) {
        if (alert.isJustified === null) {
          // console.log('CHANNELS', this.pusherRef)
          const channel = this.pusherRef.channels.channels['presence-justification-in-progress']
          // console.log('CHANNEL', channel)
          channel.trigger(
            'client-justification-in-progress',
            {
              i: alert.alarmId,
              a: alarmName,
              d: alarmDescription,
              t: 'geofenceIn',
              v: true,
              u: this.user.name
            }
          )
        }

        // console.log('ALARM FULL', this.missionAlarms)
        // console.log('ALERT', alert, alarmName, alarmDescription)
        const type = 'geofenceIn'
        this.alarmSelected = {...alert, alarmName, alarmDescription, type}
        // console.log('alarmSelected', this.alarmSelected)
        this.showJustification = true
      },
      intervalForGeofenceInAlarms() {
        this.intervalGeofenceInAlarmsInstance = setInterval(() => {
          this.fetchGeofenceInAlarms()
        }, this.intervalGeofenceInAlarmsValue)
      },
      showMessageIn(data) {
        this.messageToShow = data.message
        this.showMessage = true
      },
      closeMessage() {
        this.messageToShow = ''
        this.showMessage = false
      }
    },
    mounted() {
      this.setLoadingGeofenceInAlarms(true)
      this.fetchGeofenceInAlarms()
      this.intervalForGeofenceInAlarms()
    },
    beforeDestroy() {
      clearInterval(this.intervalGeofenceInAlarmsInstance)
      this.clearGeofenceInAlarms()
    }
  }
</script>

<style lang="scss" scoped>
  a {
    text-decoration: none;
    color: white;
  }

  a:hover {
    opacity: 0.7;
  }

  .info-width {
    min-width: 960px;
    max-width: 1024px;
  }

  .general-info-container {
    height: 60px;
    border-radius: 3px;
    background-color: #424242;
  }

  .header-container {
    height: 35px;
    border-radius: 3px;
    background-color: #424242;
    font-size: 16px;
    font-weight: 500;
  }

  .info-mission {
    min-width: 290px;
    max-width: 290px;
  }

  .description-style {
    min-width: 390px;
    max-width: 390px;
  }

  .bg-row {
    background-color: rgba(255, 255, 255, 0.07);
    border-radius: 2px;
  }

  .justification-style {
    min-width: 80px;
    max-width: 80px;
    text-align: right;
  }

  .plate-style {
    min-width: 80px;
    max-width: 80px;
  }

  .code-style {
    min-width: 90px;
    max-width: 90px;
  }

  .agency-style {
    min-width: 200px;
    max-width: 200px;
  }

  .geofence-style {
    min-width: 100px;
    max-width: 100px;
  }

  .duration-style {
    min-width: 80px;
    max-width: 80px;
  }

  .date-style {
    min-width: 140px;
    max-width: 140px;
  }

  .in-progress-state {
    border: dashed 1px #FFD54F;
    border-radius: 10px;
    max-width: 85px;
    min-width: 85px;
    max-height: 40px;
    min-height: 40px;
    margin-left: -15px;
    padding-right: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/GeofenceInAlerts.vue